module.exports = __webpack_public_path__ + "img/card-2.6b8342fa.png";